import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ArticlesListingTable, { ArticlesTitle, ArticleExcerpt } from "../../../reusable/Articles/ArticlesListingTable";
import { DropdownFilter, DateCell, RiskLevel } from "../../../reusable/LightTable/Components";
import { SORT, PESTLE_SELECT_OPTIONS, RISKS_SELECT_OPTIONS, LANGUAGE_SELECT_OPTIONS, DEFATULT_TABLE_PAGE_SIZE } from "../../../constants";
import { injectIntl } from 'react-intl';
import api from './PreviewCompany.api';

const getDefaultLoadParams = (entityId, filters, sorting) => ({
        filters: { entityId, ...filters },
        sorting,
        pagination: { pageNumber: 0, pageSize: DEFATULT_TABLE_PAGE_SIZE },
        reset: false
    });

class PreviewCompanyArticleTable extends ArticlesListingTable {
    static propTypes = {
        entityId: PropTypes.string.isRequired,
        onChangeParams: PropTypes.func, // needed for saving the filter in preferences somewhere in parent
        onClickArticle: PropTypes.func,
        onDataUpdate: PropTypes.func,
        filters: PropTypes.object,
        sorting: PropTypes.object,
    }

    static defaultProps = {
        filters: { language: "all", riskAngle: "ANY_PESTLE", riskLevel: "ANY_LEVEL" },
        sorting: { sortBy: "date", direction: SORT.DESC }
    }

    constructor(props) {
        super(props);
        this.defaultLoadParams = this.loadParams = getDefaultLoadParams(props.entityId, props.filters, props.sorting);
        this.api = api;
    }

    loadItems(params, retry = false) {
        if (params) {
            this.props.onChangeParams(params.filters || {}, params.sorting || {})
        }
        return super.loadItems(params, retry);
    }

    getHeaderItems() {
        return [
            { key: "title", label: <ArticlesTitle articleCount={this.state.totalCount} filterCount={this.state.filterCount}/>},
            { key: "language", label: <DropdownFilter filter={this.getLanguageFilter()} onChange={this.applyFilter('language')}/>},
            { key: "date", label: "Load Date", sortable: true },
            { key: "riskAngle", label: <DropdownFilter filter={this.getAngleFilter()} onChange={this.applyFilter('riskAngle')}/>},
            { key: "riskLevel", label: <DropdownFilter filter={this.getLevelFilter()} onChange={this.applyFilter('riskLevel')}/>}
        ];
    }

    applyFilter = (filter) => (e) => this.loadItems({ filters: { [filter]: e.target.value }, reset: true });

    getLanguageFilter() {
        return {
            field: "language",
            options: Object.keys(LANGUAGE_SELECT_OPTIONS).map(key => ({
                label: this.props.intl.formatMessage({ id: LANGUAGE_SELECT_OPTIONS[key] }),
                value: key
            })),
            value: this.loadParams.filters.language
        }
    }

    getAngleFilter() {
        return {
            field: "riskAngle",
            options: Object.keys(PESTLE_SELECT_OPTIONS).map(key => ({
                label: this.props.intl.formatMessage({ id: PESTLE_SELECT_OPTIONS[key] }),
                value: key
            })),
            value: this.loadParams.filters.riskAngle
        }
    }

    getLevelFilter() {
        return {
            field: "riskLevel",
            options: Object.keys(RISKS_SELECT_OPTIONS).map(key => ({
                label: this.props.intl.formatMessage({ id: RISKS_SELECT_OPTIONS[key] }),
                value: key
            })),
            value: this.loadParams.filters.riskLevel
        };
    }

    // Overriding manageApiCalls since for the preview request we get the counts and the results in the same call
    _manageApiCalls(loadParams) {
        const { filters, sorting, pagination } = loadParams;
        return new Promise((resolve, reject) => {
            this.api.get(filters, sorting, pagination).then(result => {
                const { articleList, totalCount, filterCount } = result.body;
                if (this.props.onDataUpdate) {
                    this.props.onDataUpdate(articleList, totalCount, filterCount);
                }
                this._setCountAndItems(articleList, filterCount, totalCount);
                resolve(articleList);
            }).catch(e => reject(e));
        });
    }

    render = () => <div className="infinite-scroll-table ">{super.render()}</div>;
}

export default injectIntl(PreviewCompanyArticleTable);



// WEBPACK FOOTER //
// ./src/scripts/pages/PreviewCompany/components/PreviewCompanyArticleTable.jsx